import { Outlet } from "react-router-dom";

export default function ReportManager(props: any) {
  return (
    <div className="ReportManager" style={{ height: "100%" }}>
      <Outlet />
    </div>
  );
}
